import { render, staticRenderFns } from "./payplatform.vue?vue&type=template&id=651f7e94&scoped=true"
import script from "./payplatform.vue?vue&type=script&lang=js"
export * from "./payplatform.vue?vue&type=script&lang=js"
import style0 from "./payplatform.vue?vue&type=style&index=0&id=651f7e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f7e94",
  null
  
)

export default component.exports